var Freezer = require('./src/freezer');
module.exports = Freezer;